export default "__VITE_ASSET__5dd6e6ec__"